/**
 * @fileoverview Notification Permission Pre-Prompt Screen
 * 
 * Explains notification benefits before triggering the native iOS/Android prompt.
 * Only shown on native platforms (Capacitor).
 */

import { OnboardingScreen } from './OnboardingScreen';
import { Button } from '@/components/ui/button';
import { Bell, Users } from 'lucide-react';
import notificationsHero from '@/assets/onboarding-notifications-hero.jpg';

interface NotificationPermissionScreenProps {
  onEnable: () => void;
  onSkip: () => void;
  isRequesting?: boolean;
}

export function NotificationPermissionScreen({ 
  onEnable, 
  onSkip, 
  isRequesting = false 
}: NotificationPermissionScreenProps) {
  return (
    <div className="h-[100dvh] w-full">
      <OnboardingScreen
        posterSrc={notificationsHero}
        icon={Bell}
        headline="Stay in the loop"
        subtext="Price drops, back-in-stock alerts, new style picks, and updates from friends - all delivered instantly."
      >
        <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground py-1">
          <Users className="w-3 h-3" />
          <span>87% of WNTD users keep notifications on</span>
        </div>
        <Button
          onClick={onEnable}
          disabled={isRequesting}
          size="lg"
          className="w-full text-base font-semibold h-14 rounded-2xl"
        >
          {isRequesting ? 'Enabling...' : 'Enable Notifications'}
        </Button>
        <button
          onClick={onSkip}
          className="w-full text-center text-sm text-muted-foreground py-2 active:text-foreground transition-colors"
        >
          Maybe Later
        </button>
      </OnboardingScreen>
    </div>
  );
}
